<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-07 20:00:21
 * @LastEditTime: 2019-10-09 17:20:30
 * @LastEditors: Please set LastEditors
 -->
<template>
    <el-dialog
        class="dealerDialog"
            title="选择门店"
            :visible="true"
            :append-to-body='true'
            width="60%"
            :before-close="handleClose"
    > 

            <el-form ref="form1" :model="form1" label-width="100px" :inline="true" class="mt20">
                    <el-form-item label="门店编号:">
                        <el-input v-model="form1.shop_sn" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="门店名称:">
                        <el-input v-model="form1.shop_name" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="类型:">
                        <el-select clearable v-model="form1.isself" size="small">
                            <el-option v-for=" i in storeArr" :key="i.id" :label="i.label"
                                       :value="i.id"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="关键词:">
                        <el-input v-model="form1.keywords" clearable placeholder="手机号,负责人"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getStore()">搜索</el-button>
                    </el-form-item>
                </el-form>
                <span>提示：门店资料请【客户】-【门店管理】中添加、管理，发货给门店只能选择直属总部的门店.</span>
                <!--表格-->
                <el-table
                        ref="multipleTable"
                        :data="tableData2"
                        v-loading="loading"
                        height="250"
                        border
                            @selection-change='select'
                        style="width: 100%;margin: 20px 0">
                         <el-table-column
                            type="selection"
                           width="55"
                                 v-if='selects'
                           >
                    </el-table-column>
                    <el-table-column
                            prop="shop_sn"
                            label="门店编号"
                            width="120"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="shop_name"
                            width="180"
                            label="门店名称"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="address"
                            label="门店地址"
                            width="180"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="mobile"
                            label="手机号"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="person"
                            label="负责人"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="isself"
                            label="类型"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop=""
                            label="操作"
                            width="180"
                            show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="chooseStore(scope.row)">选择</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!--分页-->
                <el-pagination
                        style="margin: 20px 0"
                        @size-change="handleSizeChange2"
                        @current-change="handleCurrentChange2"
                        :current-page="pageNo2"
                        :page-sizes="[20, 50, 100, 200]"
                        :page-size="pageSize2"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalSize2">
                </el-pagination>

       <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">取 消</el-button>
    <el-button type="primary" @click="confrim">确 定</el-button>
  </span>
    </el-dialog>
</template>


<script>
export default {
    name:'selectStore',
    data(){
        return{
             pageNo2: 1,//页码
                pageSize2: 20,//每页现实的条数
                totalSize2: 0,//总条数
                 storeArr:[
                    {
                        label:'全部',
                        id:'',
                    },
                    {
                        label:'直营门店',
                        id:1,
                    },
                    {
                        label:'非直营门店',
                        id:2,
                    }
                ],
                 tableData1: [],
                tableData2: [],
                multipleSelection: [],
                  form1: {
                    shop_name:'',
                    shop_sn:'',
                    isself:'',
                    keywords:''
                },
                selectData:[]
        }
    },
      props:{
            selects:Boolean,
            putaway:Object
        },
    methods:{
      
          //选择门店
            chooseStore(row){
                this.$emit('pushData',row);
                this.$emit('handleClose');
            },
            //查询门店
            getStore(){
                this.loading = true;
                this.$get('logistics','/shops', {
                    per_page:this.pageSize2,
                    page:this.pageNo2,
                    shop_sn:this.form1.shop_sn,
                    shop_name:this.form1.shop_name,
                    isself:'',
                    keywords:this.form1.keywords
                }).then(res => {
                    this.loading = false;
                    this.tableData2 = res.data;
                    this.totalSize2 = res.meta.total;
                    console.log(this.putaway.exclude_shops)
                    this.tableData2= this.tableData2.filter((val)=>{
                      
                        return this.putaway.exclude_shops.indexOf(val.shop_sn)==-1
                    });
                }).catch(function (error) {
                    this.loading = false;
                 
                });

            },
               select(value){
                this.selectData=value
         

            },
            // 确认选择经销商
            confrim(){
                this.$emit('pushData',this.selectData);
                this.$emit('handleClose');
            },
            handleSizeChange2(val) {
                this.pageSize2 = val;
                this.pageNo2 = 1;
                this.getStore()
            },
            handleCurrentChange2(val) {
                this.pageNo2 = val;
                this.getStore()

            },
            handleClose() {
                this.$emit('handleClose');
            }
    }
    ,
        created() {
       
            this.getStore();

        }
}
</script>
